module.exports = __webpack_public_path__ + "img/5-2.d7033a0b.svg";